import React from 'react';
import classNames from 'classnames';

export const DeleteContainer = ({
  className,
  ...props
}: React.ComponentProps<'div'>) => {
  return (
    <div
      className={classNames(
        'h-3 w-3 cursor-pointer flex justify-center items-center rounded-full hover:bg-gray-300',
        className
      )}
      {...props}
    />
  );
};
